export default function OrangeEyeIcon() {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 3.93652C3.375 3.93652 1.125 8.99957 1.125 8.99957C1.125 8.99957 3.375 14.0615 9 14.0615C14.625 14.0615 16.875 8.99957 16.875 8.99957C16.875 8.99957 14.625 3.93652 9 3.93652Z"
          stroke="#FE7235"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 11.8121C10.5533 11.8121 11.8125 10.5529 11.8125 8.99962C11.8125 7.44631 10.5533 6.18712 9 6.18712C7.4467 6.18712 6.1875 7.44631 6.1875 8.99962C6.1875 10.5529 7.4467 11.8121 9 11.8121Z"
          stroke="#FE7235"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
